import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Toast } from 'react-bootstrap';
import apiClient from '../utils/api';
function Tracking() {
  const [searchParams] = useSearchParams();
  const [ticketNumber, setTicketNumber] = useState('');
  const [toast, setToast] = useState({
    show: false,
    message: '',
    variant: 'success'
  });
  const [formState, setFormState] = useState({
    isTicketChecked: false
  });

  useEffect(() => {
    const ticketFromUrl = searchParams.get('ticket');
    if (ticketFromUrl) {
      setTicketNumber(ticketFromUrl);
      handleCheckTicket(ticketFromUrl);
    }
  }, [searchParams]);

  const handleCheckTicket = async (ticket) => {
    if (!ticket || !ticket.trim()) {
      setToast({
        show: true,
        message: 'Please enter a valid Plate or Ticket Number.',
        variant: 'danger'
      });
      return;
    }

    try {
      const response = await apiClient.post('/verify-ticket', {
        ticket_number: ticket.trim()
      });

      if (response.data.exists) {
        setFormState({
          isTicketChecked: true
        });
      } else {
        setToast({
          show: true,
          message: 'Invalid ticket or plate number. Please check and try again.',
          variant: 'danger'
        });
        setFormState({
          isTicketChecked: false
        });
      }
    } catch (error) {
      console.error('Error verifying ticket:', error);
      setToast({
        show: true,
        message: 'Error verifying ticket. Please try again.',
        variant: 'danger'
      });
    }
  };

  const handleSubmitRequest = async () => {
    try {
      const response = await apiClient.post('/payment-update', {
        ticket_number: ticketNumber
      });

      if (response.data.success) {
        // Show success modal with appropriate message
        const successMessage = 'We have received your request. Please wait, your car is on the way.';

        // Reset form
        setTicketNumber('');
        setFormState({
          isTicketChecked: false
        });

        setToast({
          show: true,
          message: successMessage,
          variant: 'success'
        });
      }
    } catch (error) {
      console.error('Error updating payment:', error);
      setToast({
        show: true,
        message: error.response?.data?.message || 'Error processing your request. Please try again.',
        variant: 'danger'
      });
    }
  };

  return (
    <>
    <Toast 
      show={toast.show} 
      onClose={() => setToast(prev => ({ ...prev, show: false }))}
      delay={5000}
      autohide
      style={{
        position: 'fixed',
        top: 20,
        right: 20,
        zIndex: 9999,
        minWidth: '300px'
      }}
      bg={toast.variant}
      text={toast.variant === 'dark' ? 'white' : 'dark'}
    >
      <Toast.Header closeButton>
        <strong className="me-auto">Notification</strong>
      </Toast.Header>
      <Toast.Body>{toast.message}</Toast.Body>
    </Toast>
      <section className="inner-intro bg-1 bg-overlay-black-70">
        <div className="container">
          <div className="row text-center intro-title">
            <div className="col-md-12 text-md-start d-inline-block">
              <div className="section-title">
                <h2 className="text-center" style={{color: 'white'}}>Vehicle Tracking</h2>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="welcome-4 page-section-ptb dark-bg">
        <div className="container">
          <section className="tracking-section">
            <div className="container">
              <div className="row">
                <div className="section-title" style={{marginBottom: '10px'}}>
                  <h2 className="justify-content-center" style={{color: 'white'}}>Track Your Vehicle</h2>
                  <div className="separator justify-content-center"></div>
                  <p style={{color: '#f7f7f7'}}>Enter your Plate or Ticket Number to track your car and request delivery to your preferred exit point.</p>
                </div>
                <div className="col-lg-8 mx-auto">
                  <div className="tracking-form">
                    <form id="trackingForm">
                      <div className="form-group">
                        <input 
                          type="text" 
                          className="form-control" 
                          id="ticketNumber" 
                          placeholder="Enter your Plate or Ticket Number"
                          value={ticketNumber}
                          onChange={(e) => setTicketNumber(e.target.value)}
                          required 
                        />
                      </div>

                      {formState.isTicketChecked && (
                        <div className="text-center mt-3" id="viewTicketBtnContainer">
                          <div className="alert alert-success" role="alert">
                            <i className="fa fa-check-circle"></i> Ticket verified successfully! 
                          </div>
                        </div>
                      )}

                      <div className="text-center mt-4">
                        {!formState.isTicketChecked ? (
                          <button 
                            type="button" 
                            className="button red btn-block"
                            onClick={() => handleCheckTicket(ticketNumber)}
                          >
                            Check Car
                          </button>
                        ) : (
                          <button 
                            type="button" 
                            className="button red btn-block"
                            onClick={handleSubmitRequest}
                          >
                            Order Car
                          </button>
                        )}
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>

      {/* Testimonials Section */}
      {/* <section className="testimonial-3 white-bg page-section-ptb">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="section-title">
                <span>What Our Happy Clients say about us</span>
                <h2>Our Testimonial</h2>
                <div className="separator"></div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="owl-carousel owl-theme" data-nav-dots="true" data-items="1" data-md-items="1" data-sm-items="1" data-xs-items="1" data-space="15">
                <div className="item">
                  <div className="testimonial-block">
                    <div className="row">
                      <div className="col-lg-3 col-md-3 col-sm-3">
                        <div className="testimonial-avtar">
                          <img className="img-fluid center-block" src="images/team/01.jpg" alt="" />
                        </div>
                      </div>
                      <div className="col-lg-9 col-md-9 col-sm-9">
                        <div className="testimonial-content">
                          <p><i className="fa fa-quote-left"></i> <span>The team handled everything professionally from the moment I arrived. The drop-off was quick, and the return was even faster. It made a great impression on our guests, and I didn't have to worry about parking for a single second during the event.</span> <i className="fa fa-quote-right float-end"></i></p>
                        </div>
                        <div className="testimonial-info">
                          <h6>Hamad Al-Mansoori</h6>
                          <span>Customer</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="item">
                  <div className="testimonial-block">
                    <div className="row">
                      <div className="col-lg-3 col-md-3 col-sm-3">
                        <div className="testimonial-avtar">
                          <img className="img-fluid center-block" src="images/team/01.jpg" alt="" />
                        </div>
                      </div>
                      <div className="col-lg-9 col-md-9 col-sm-9">
                        <div className="testimonial-content">
                          <p><i className="fa fa-quote-left"></i> <span>I've used valet services before, but this one stood out. The staff was polite, they noted all details carefully, and the car was returned exactly where I asked. Smooth process throughout, and that really helped me stay focused on the event.</span> <i className="fa fa-quote-right float-end"></i></p>
                        </div>
                        <div className="testimonial-info">
                          <h6>Sara Al-Naemi</h6>
                          <span>Customer</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="item">
                  <div className="testimonial-block">
                    <div className="row">
                      <div className="col-lg-3 col-md-3 col-sm-3">
                        <div className="testimonial-avtar">
                          <img className="img-fluid center-block" src="images/team/01.jpg" alt="" />
                        </div>
                      </div>
                      <div className="col-lg-9 col-md-9 col-sm-9">
                        <div className="testimonial-content">
                          <p><i className="fa fa-quote-left"></i> <span>Service was well-organized and quick. I dropped my car, shared my number, and got a clear ticket with a QR. Requested it later, and it was brought right to me without delay. Everything felt controlled and easy without any unnecessary steps.</span> <i className="fa fa-quote-right float-end"></i></p>
                        </div>
                        <div className="testimonial-info">
                          <h6>Fahad Al-Kuwari</h6>
                          <span>Customer</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
    </>
  );
}

export default Tracking;
